import { List } from 'immutable'
export default function stubImmutableList() {
  return List([])
}
